import React, { useReducer, useContext, useMemo, useEffect, useState, useLayoutEffect } from 'react'
import {
    Box, Tooltip, TextField, Divider, Select, MenuItem, FormControl, InputLabel,
    Grid, FormGroup, FormControlLabel, Checkbox, Typography, FormLabel, IconButton, CircularProgress
} from '@mui/material'
import toast from 'react-hot-toast'
import dayjs from 'dayjs';
import { defaultReducer, lockedReducer } from '../../Utils/reducers'
import { api } from '../../../services/api'
import Table from '../../Table';
import ColorButton from '../../Buttons/ColorButton';
import DefaultModal from '../../Utils/DefaultModal';
import { formatCurrency, formatPercentage } from '../../Utils/IntegerOnly';
import { externalComponent } from '../../AppRoutes';
import MegaAutoComplete from '../../Utils/megautocomplete';
import ProductModal from './product_modal';
import { NumericFormatInput } from '../../Utils/NumericInput';
import { PercentFormatInput } from '../../Utils/PercentInput';
import DeleteIcon from '@mui/icons-material/Delete'
import './style.css'
import ConfirmationDialog from '../../Utils/ConfirmationDialog';
import SelectCustomCondpag from './select-custom-condpag';
import PoolTextField from '../../Utils/pool-text-field';
import { submitDelete, submitInibeCancelamento } from './index'
import apptheme from '../../theme/default';
import { apiFetch } from '../../../services/fetch';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import SelectCard from './select-card';
import SelectBank from './select-bank';
import { groups, hasPermissions } from '../../Utils/groups';
import Historic from './historic';
import FichaFinanceira from './ficha';
import WarningIcon from '@mui/icons-material/Warning';
import { getSession } from '../../../contexts/auth';

const url = '/novopedido/'

let internal_representatives = {}
let internal_origin_stock = {}
let tabelas_de_valores = {}

let timeout = 0
const timeoutTime = 100
let last_discount = 0
let lock_hash = ''
let retry = 0
let last_origin_stock = null


let locktimeout = 0

const request_action = async (observation = "", data, setLoader) => {
    setLoader(true)
    const res = await api.post(`${url}action/${data.id}/`, { observation: observation })
    setLoader(false)
    if (res.status === 200) {
        toast.success(res.data)
    } else {
        toast.error(res.data)
    }
}

const liberaPedido = async (data, setLoader) => {

    setLoader(true)

    const payload = {
        'numped': data.id,
        'hash': data.hash
    }

    const res = await api.post('/liberapedido/', payload)
    setLoader(false)
    if (res.status !== 200) {
        toast.error(`Falha na liberação do pedido: ${res.data}`)
        return false
    } else {
        toast.success("Pedido liberado com sucesso!")
        return true
    }
}

const changeData = (props, rows, newvalue, setState, extra = {}) => {
    clearTimeout(timeout)
    const row = rows.find(row => row.id === props.row.id)
    const value = { id: props.row.id, [props.field]: newvalue, ...extra }
    Object.assign(row, value)
    props.api.updateRows([value])
    timeout = setTimeout(() => {
        setState({ products_rows: [...rows] })
    }, timeoutTime)
}

const calcDiscount = (freteflag, config, payment_condition, volume_discount) => {
    let totalDiscount = 100
    if (freteflag && config?.preco_frete?.value_perc)
        totalDiscount -= (config.preco_frete.value_perc) / 100
    if (payment_condition)
        totalDiscount -= payment_condition / 100
    if (volume_discount)
        totalDiscount -= volume_discount / 100
    return totalDiscount / 100
}

const calcPaymentCondition = (payment_condition, tipo_doc, configs, values_table) => {

    console.log(payment_condition, tipo_doc, configs, values_table)

    if (payment_condition?.avista) {
        const origin_desc = payment_condition?.debito ? payment_condition?.data?.origin_desc : 0
        return (configs.desconto_vista?.value_perc || 0) +
         (values_table?.data?.desc || 0) + 
          (payment_condition?.data?.val_desc || 0) +
          origin_desc
    }
    return payment_condition?.data?.val_desc || 0
}

const getcolumns = (setState, setModal, state, validations, viewOnly) => {
    const columns = []

    columns.push({ field: 'Cod', headerName: 'Código', flex: 0.1, filterType: 'string', align: "center" })
    columns.push({ field: 'Descricao', headerName: 'Descrição', flex: 0.7, filterType: 'string', sort: 'desc' })
    columns.push({ field: 'PesoLiquido', headerName: 'Peso(Kg)', flex: 0.15, filterType: 'string', align: "center" })
    columns.push({ field: 'Cubagem', headerName: 'M³', flex: 0.1, filterType: 'string', align: "center" })
    columns.push({
        field: 'QuantidadeVenda', headerName: 'Quant', flex: 0.2, filterType: 'string', align: "center",
        renderCell: (props) => {
            return (
                <Box sx={{ width: '90%' }}>
                    <TextField
                        disabled={!validations.table_selected || viewOnly}
                        value={props.value}
                        type="text"
                        onChange={(e) => changeData(props, state.products_rows, e.target.value, setState)}
                        InputProps={{
                            sx: { fontSize: '13px' }
                        }}
                    />
                </Box>)
        }
    })
    columns.push({
        field: 'comissao', headerName: 'Comissão', flex: 0.2, filterType: 'string',
        renderCell: (props) => {
            return (
                <Box sx={{ width: '90%' }}>
                    <TextField
                        disabled={!validations.table_selected || viewOnly}
                        value={props.value}
                        type="text"
                        InputProps={{
                            inputComponent: PercentFormatInput,
                            sx: { fontSize: '13px' }
                        }}
                        onChange={(e) => changeData(props, state.products_rows, e.target.value, setState)}

                    />
                </Box>
            )
        }
    })
    columns.push({
        field: 'preco_base_discount', headerName: 'Preço Base', flex: 0.2, filterType: 'string', align: "center",
        renderCell: ({ value, row }) => <Box>{formatCurrency((value || row.preco_base) / 100)}</Box>
    })
    columns.push({
        field: 'preco', headerName: 'Preço Utilizado', flex: 0.3, filterType: 'string', align: "center",
        renderCell: (props) => {
            return (
                <Box sx={{ width: '90%' }}>
                    <TextField
                        disabled={!validations.table_selected || viewOnly}
                        id="valor"
                        type="text"
                        value={props.value / 100}
                        onChange={(e) => { changeData(props, state.products_rows, e.target.value * 100, setState, { changed: e.target.value * 10 === props.value }) }}
                        fullWidth={false}
                        size='small'
                        sx={{ fontSize: '13px' }}
                        onKeyDown={(e) => e.stopPropagation()}
                        InputProps={{
                            inputComponent: NumericFormatInput,
                            sx: { fontSize: '13px' }
                        }}
                    />
                </Box>)
        }
    })
    columns.push({
        field: 'TotalFinal', headerName: 'Total Final', flex: 0.2, filterType: 'string', align: "center",
        renderCell: ({ value }) => <Box>{formatCurrency(value / 100)}</Box>
    })
    //columns.push({ field: 'Pendencia', headerName: 'Pendência', flex: 0.2, filterType: 'string', renderCell: ({ id }) => (state.pendencias?.[id] || []).join(', ') })
    if (validations.table_selected) {
        columns.push({
            field: 'descontomanual', headerName: 'Desconto manual', width: 80, filterType: 'string', renderCell: (props) => (
                <Tooltip title='Desconto manual'>
                    <span>
                        <Checkbox
                            checked={props.value}
                            disabled={viewOnly}
                            onChange={(e) => changeData(props, state.products_rows, e.target.checked, setState, { checked: e.target.checked })}
                        />
                    </span>
                </Tooltip>
            )
        })
        if (!viewOnly)
            columns.push({
                field: 'action', headerName: 'Remover', width: 80, filterType: 'string', renderCell: ({ row }) => (
                    <Tooltip title='Remover produto'><IconButton
                        onClick={() => {
                            setModal({ delete: row })
                        }}
                    ><DeleteIcon /></IconButton></Tooltip>
                )
            })
    }

    return columns
}

const calcTotal = (products, discount) => {
    let total_quant = 0;
    let total_peso = 0;
    let total_cubo = 0;
    let valor_total = 0;
    let produto_total = 0;
    let comissao_valor_total = 0;
    let comissao_pct_total = 0;
    let comissao_total = 0;
    let saldo_ped = 0;
    // const discount_applied = (3 - (comission * 100 || 3))
    // const reverse_comission = (1 - discount_applied / 100)

    products.forEach(product => {
        total_quant += parseInt(product.QuantidadeVenda);
        total_peso += product.PesoLiquido * parseInt(product.QuantidadeVenda);
        total_cubo += product.Cubagem * parseInt(product.QuantidadeVenda);

        const discount_applied = (3 - (product.comissao || 3))
        const reverse_comission = (1 - discount_applied / 100)

        const preco_base_discount = Math.round(product.preco_base * discount)
        if ((product.preco_base_discount || product.preco_base) === product.preco) {
            product.preco_orig = preco_base_discount
            product.preco = Math.round(preco_base_discount * reverse_comission)
        }
        product.preco_base_discount_orig = preco_base_discount
        product.preco_base_discount = Math.round(preco_base_discount * reverse_comission)
        product.discount_applied = discount_applied
        product.preco_usado = (product.precoNumber || product.preco)

        produto_total = (parseInt(product.QuantidadeVenda) * (product.precoNumber || product.preco));
        const preco_base_total = (product.preco_base_discount) * parseInt(product.QuantidadeVenda)
        product.TotalFinal = produto_total;
        product.preco_usado_orig = product.preco_usado / reverse_comission
        product.TotalFinal_orig = produto_total / reverse_comission
        product.TotalFinalFormatted = formatCurrency(product.TotalFinal);
        valor_total += produto_total;
        saldo_ped += !product.descontomanual ? (produto_total - preco_base_total) : 0
        product.comissao = Math.min(product.comissao, last_comission * 100)
        const comissao_pct = product.comissao / 100;
        comissao_valor_total += produto_total * comissao_pct;

    });
    comissao_pct_total = Math.round(valor_total > 0 ? (comissao_valor_total / valor_total) * 100 : 0)/100;
    comissao_total = valor_total * (comissao_pct_total);
    valor_total = valor_total;
    comissao_total = comissao_total;

    return {
        total_quant,
        total_peso,
        total_cubo,
        valor_total,
        comissao_total,
        comissao_pct_total,
        saldo_ped
    }
}

const calcDefault = (setState, state, discount) => {

    let { total_quant, total_peso, total_cubo, valor_total, comissao_total, comissao_pct_total, saldo_ped } = calcTotal(state.products_rows, discount);
    const newstate = {
        quantity: total_quant,
        weight: total_peso,
        cube_size: total_cubo,
        total_price: valor_total,
        saldo_ped: saldo_ped,
        commission_amount: comissao_total,
        commission_percent: comissao_pct_total
    }

    if (discount !== last_discount) {
        newstate.products_rows = [...state.products_rows]
        last_discount = discount
    }
    setState(newstate)
}

const submit = async (data, getData, setLoader, reloaddata) => {

    setLoader(true)
    let res = null

    const { dump, ...payload } = data

    if (payload.id)
        res = await api.patch(`${url}${data.id}/`, payload)
    else
        res = await api.post(url, payload)
    if (res.status === 201 || res.status === 200) {
        toast.success(`Pedido salvo com sucesso`)
        getData()
        reloaddata(res.data.id)
        setLoader(false)
        return res.data.id
    }
    toast.error(`Pedido não pôde ser salvo. Motivo: ${res.data}`)
    setLoader(false)
    return false
}

const submit_elevor = async (data, getData, setLoader, loadRetrieve) => {

    setLoader(true)

    toast.success(`Enviando ao ERP.`)

    const res = await api.post(`${url}elevor/${data.id}/`, data)
    if (res.status === 200) {
        getData()
        await loadRetrieve()
        toast.success(`Pedido enviado com sucesso`)
        setLoader(false)
        return
    }
    getData()
    toast.error(`Pedido não pôde ser enviado. Motivo: ${res.data}`)
    setLoader(false)
}

const loadRepresentative = async (id, setState, setLoading) => {
    setLoading(true)
    const res = await api.get(url + `representantes/${id}/`)
    if (res.status === 200) {
        setState(res.data)
    }
    setLoading(false)
}


const loadRetrieve = async (id, setState, setLoader, handleClose = () => { }, controller = () => { }, viewOnly = false) => {
    setLoader(true)
    let load_url = url + `${id}/?lock_hash=${lock_hash || ''}`
    if (viewOnly) load_url = url + `${id}/?nolock=true`

    const res = await api.get(load_url)
    setLoader(false)
    if (res.status === 200) {
        lock_hash = res.data.lock_hash
        canClear = false
        setState({
            ...res.data.dump,
            id: res.data.id,
            hash: res.data.hash,
            liberacao: res.data.liberacao,
            status: res.data.status,
            ready: true,
            pendencias: res.data.pendencias,
            clean: true,
            ignore_cancel: res.data.ignore_cancel
        })
        if (!viewOnly) controller()
    }
    else if (res.status === 400) {
        toast.error(<>{res.data} <Tooltip title='Liberar pedido'>
            <span className='flex-column'>
                <ColorButton onClick={() => releaseLock(id)}>
                    <LockOpenIcon />
                </ColorButton>
            </span>
        </Tooltip>
        </>)
        handleClose()
    } else {
        toast.error(`Houve um erro para abrir o pedido.`)
        handleClose()
    }
}

const releaseLock = async (id) => {
    const res = await api.get(url + `${id}/releaselock/`)
    if (res.status === 200) {
        toast.success('Pedido liberado com sucesso!')
        return
    }
    toast.error('Pedido não pôde ser liberado.')
}

const lockPedido = async (id, signal, handleClose) => {


    try {
        const response = await apiFetch('novopedido/' + `${id}/lock/`, { signal, timeout: 0 })
        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        while (true) {
            const { done, value } = await reader.read();
            retry = 0
            if (done) {
                console.log("Stream disconnected.");
                handleClose()
                break;
            }
            let message = decoder.decode(value, { stream: true });
            if (message.includes('}{')) {
                message = message.split('}{')[0] + '}'
            }
            const parse_message = JSON.parse(message)

            if (parse_message.hash !== lock_hash) {
                toast.error(`Você foi retirado do pedido por um administrador.`)
                handleClose()
                return
            }

            clearTimeout(locktimeout)
            locktimeout = setTimeout(() => {
                toast.error('Pedido desconectado. Motivo: Sem resposta do servidor.')
                handleClose()
            }, 5000)

        }
    } catch (error) {
        if (error.name !== "AbortError") {
            console.error("Stream error:", error);
            if (retry === 3) {
                handleClose()
            }
            retry++;
        }
    }

}


const getTitle = (data) => {
    if (data?.id)
        return 'Salvar'
    return 'Salvar'
}

const setSelectedProducts = (setState, products) => {
    setState({ products_rows: [...products] })
}

export const normalize = (value) => {
    // Remove any formatting (masks) from CPF/CNPJ
    return value.replace(/\D/g, ""); // Keep only numbers
}

const SaldoBox = ({ representative, saldoRep, setSaldoRep }) => {

    const [loading, setLoading] = useState(0)

    useLayoutEffect(() => {
        if (representative?.id)
            loadRepresentative(representative.id, setSaldoRep, setLoading)
    }, [representative])

    return (
        <>
            {
                loading ?
                    <Box sx={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
                        <CircularProgress sx={{ color: apptheme.primaryColor }} size={20} />
                    </Box>
                    :
                    <Typography variant="body1">
                        {formatCurrency((saldoRep?.saldo || 0) / 100)}
                    </Typography>
            }
        </>
    )
}

const validateState = (state) => {
    if (['', 'aguardando_envio', 'aguardando_liberacao'].includes(state.status))
        return {
            initialized: true,
            product_selected: Boolean(state.tipo_pedido),
            client_selected: Boolean(state.costumer),
            table_selected: Boolean(state.values_table),
            valid: state.tipo_pedido && state.branch && state.document_type &&
                state.payment_condition && state.shipping && state.costumer &&
                state.representative && state.values_table && (state.carrier?.id || state.shipping === 2) &&
                state.origin_stock && state.products_rows?.length > 0 && (
                    hasPermissions('administrador') ||
                    (hasPermissions('representante') && JSON.parse(localStorage.getItem('vendedor') || {})?.id === state?.representative?.id) 
                )
        }
    return {}
}

let canClear = false
let cleaningTimeout = 0
const max_comission = 0.03
let last_comission = max_comission

const calc_comission = (representative) => {
    last_comission = max_comission
    if (representative?.data?.comission)
        last_comission = representative?.data?.comission / 10000
}

const EditPedido = ({ data, nextOrder, handleClose, reloadData, configs, viewOnly = false, refuseModal = () => { } }) => {

    const { setLoader } = useContext(externalComponent)

    const [tab, setTab] = useState('pedido')
    const [historic, setHistoric] = useReducer(defaultReducer, {})
    const [ficha, setFicha] = useReducer(defaultReducer, {})
    const [saldoRep, setSaldoRep] = useState(0)

    const [modal, setModal] = useReducer(lockedReducer, {
        liberation: null,
        cancel: null,
        save: null,
        send: null,
        delete: null,
        product_modal: null,
        libera_pedido: null,
        inibe_cancelamento: null
    })

    const [state, setState] = useReducer(lockedReducer, {
        status: '',
        hash: '',
        liberacao: '',
        next_number: nextOrder,
        products_rows: [],
        tipo_pedido: '',
        branch: null,
        phone: '',
        email: '',
        observation: '',
        discount: 0,
        cube_size: 0,
        quantity: 0,
        weight: 0,
        total_price: 0,
        commission_amount: 0,
        commission_percent: 0,
        document_type: null,
        document_type_flag: false,
        payment_condition: null,
        tpo: '',
        shipping: '',
        shipping_flag: false,
        costumer: null,
        city: null,
        representative: null,
        origin_stock: null,
        carrier: null,
        values_table: null,
        card: null,
        bank: null,
        liberation: '',
        ...data,
        id: data.id ? data.id : 0,
        saldo_ped: 0,
        ready: data.id ? false : true,
        pendencias: null,
        clean: false,
        ignore_cancel: false,
    })

    useEffect(() => {

        if (state.id) {
            const controller = new AbortController();
            const signal = controller.signal;
            loadRetrieve(state.id, setState, setLoader, handleClose, () => lockPedido(state.id, signal, handleClose), viewOnly)
            if (viewOnly)
                window.login_callback = () => loadRetrieve(state.id, setState, setLoader, handleClose, () => lockPedido(state.id, signal, handleClose), viewOnly)
            return () => {
                controller.abort(); // Cleanup when the component unmounts
                clearTimeout(locktimeout)
                window.login_callback = () => { }
                console.log("Stream connection closed.");
            }
        }
    }, [state.id, setLoader])

    const calc_payment_condition = state.tipo_pedido === 3 ? 0 : calcPaymentCondition(state.payment_condition, state.document_type, configs, state.values_table)

    const discount = calcDiscount(state.shipping_flag, configs, calc_payment_condition, state.costumer?.data?.volume_discount)

    useEffect(() => {

        calc_comission(state.representative)
        calcDefault(setState, state, discount);

    }, [state.products_rows, state.commission_percent, discount, state.representative])

    useEffect(() => {
        if (state.document_type)
            setState({ document_type_flag: (state.document_type?.id === 3) ? true : false })

    }, [state.document_type])

    useEffect(() => {
        if (state.clean) return
        if (state.origin_stock) {
            const filial_id = state.origin_stock?.id
            const selected_tables = tabelas_de_valores?.data?.data
            if (!selected_tables) return
            if (last_origin_stock === state.origin_stock && state.values_table === null) return // If we try to cancel the value table, but it only has one
            const set_tabelas = selected_tables.filter(tabela => tabela?.data?.filial.includes(filial_id))
            if (set_tabelas && set_tabelas.length === 1) {
                setState({ values_table: set_tabelas[0] })
            } else if (set_tabelas && set_tabelas.length === 0) {
                setState({ values_table: '' })
            } else if (!set_tabelas)
                setState({ values_table: '' })
            else if (set_tabelas && state.values_table && !set_tabelas.map(e => e.id).includes(state.values_table?.id)) {
                setState({ values_table: '' })
            }
        } else {
            setState({ values_table: '' })
        }
        last_origin_stock = state.origin_stock
    }, [state.origin_stock, state.values_table])


    //Best found
    useEffect(() => {
        clearTimeout(cleaningTimeout)
        cleaningTimeout = setTimeout(() => { canClear = true }, 500)
    }, [state.ready, state.clean])

    useEffect(() => {



        if (state.ready && canClear && state.clean)
            setState({ clean: false })
    }, [state])

    const validations = validateState(state)

    const memo_columns = useMemo(() => getcolumns(setState, setModal, state, validations, viewOnly), [state.products_rows, modal.edit, validations])

    return (<>
        {
            modal.product_modal &&
            <ProductModal
                setSelectedProducts={setSelectedProducts}
                setProducts={setState}
                tabela_id={state.values_table.id}
                productsSelecteds={state.products_rows}
                handleClose={() => setModal({ product_modal: null })}
                origin_stock={state.origin_stock}
            />
        }
        {modal.libera_pedido &&
            <ConfirmationDialog
                content={`Deseja liberar o pedido ${modal.libera_pedido?.id}?`}
                handleClose={() => setModal({ libera_pedido: null })}
                onConfirm={(data) => {
                    liberaPedido(state, setLoader).then((res) => {
                        if (res) {
                            setModal({ libera_pedido: null });
                            loadRetrieve(state.id, setState, setLoader, handleClose, () => { }, viewOnly)
                        }
                    });
                }}
            />
        }
        {modal.liberation &&
            <ConfirmationDialog
                content={`Deseja solicitar a ${modal.liberation} do pedido?`}
                handleClose={() => setModal({ liberation: null })}
                onConfirm={(data) => {
                    request_action(data, state, setLoader).then(() => loadRetrieve(state.id, setState, setLoader));
                    setModal({ liberation: null })
                }}
                message
                messageLabel="Observação"
            />
        }
        {modal.save &&
            <ConfirmationDialog
                content={`Deseja salvar o Pedido?`}
                handleClose={() => setModal({ save: null })}
                onConfirm={() => { modal.save(); setModal({ save: null }) }}
            />
        }
        {modal.send &&
            <ConfirmationDialog
                content={`Deseja enviar o Pedido para o ERP?`}
                handleClose={() => setModal({ send: null })}
                onConfirm={() => { modal.send(); setModal({ send: null }) }}
            />
        }

        {modal.cancel &&
            <ConfirmationDialog
                content={`Deseja inutilizar o Pedido ${state.id}?`}
                handleClose={() => setModal({ cancel: null })}
                onConfirm={() => submitDelete(modal.cancel, setModal, () => { loadRetrieve(state.id, setState, setLoader); reloadData() }, setLoader)}
            />
        }
        {modal.inibe_cancelamento &&
            <ConfirmationDialog
                content={`Deseja ${state.ignore_cancel ? "Liberar":"Inibir"} o cancelamento automático do Pedido ${state.id}?`}
                handleClose={() => setModal({ inibe_cancelamento: null })}
                onConfirm={() => submitInibeCancelamento(modal.inibe_cancelamento, setModal, () => { loadRetrieve(state.id, setState, setLoader); reloadData() }, setLoader)}
            />
        }

        {modal.delete && <ConfirmationDialog
            content={`Deseja remover o produto: ${modal.delete.Descricao}?`}
            onConfirm={() => {
                setModal({ delete: null })
                setState({ products_rows: state.products_rows.filter(row => row.id !== modal.delete.id) })
            }}
            handleClose={() => setModal({ delete: null })}
        />}
        {state.payment_condition?.id === -1 && !state.payment_condition?.verified &&
            <SelectCustomCondpag
                data={state.payment_condition}
                handleClose={() => setState({ payment_condition: null })}
                submit={(verified, setvalue, val_desc) => setState({ payment_condition: { id: -1, label: setvalue, setvalue, verified, data: { val_desc: val_desc } } })}
            />
        }
        {((state.document_type?.data?.formaPag === 3 && !state.card) || state.card?.open) &&
            <SelectCard
                values_table={state.values_table}
                data={{...state.card, payment_condition: state.payment_condition}}
                handleClose={() => {
                    if (state.card) {
                        setState({ card: { ...state.card, open: false } })
                    } else {
                        setState({ card: null, document_type: null })
                    }
                }}
                submit={(flag, debito, payment_condition) => setState({ card: { flag: flag, debito: debito, open: false }, payment_condition: payment_condition })}
            />
        }
        {(([4].includes(state.document_type?.data?.formaPag) && !state.bank) || state.bank?.open) &&
            <SelectBank
                filial={state.branch}
                data={state.bank}
                handleClose={() => {
                    if (state.bank) {
                        setState({ bank: { ...state.bank, open: false } })
                    } else {
                        setState({ bank: null, document_type: null })
                    }

                }}
                submit={(bank) => setState({ bank: { bank: bank, open: false } })}
            />
        }
        <DefaultModal
            disableModal={viewOnly}
            dialogProps={{
                sx: {
                    '& .MuiPaper-root': {
                        maxWidth: 'unset',
                        maxHeight: 'unset',
                        width: '95%',
                        height: '95%',
                        margin: '0px'
                    },
                    '& .MuiDialogContent-root': {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '1rem'
                    }
                }
            }}
            title={
                `${getTitle(state)} Pedido`
            }
            open={state.ready}
            handleClose={handleClose}
            content={
                <>
                    {Boolean(state.id) &&
                        <Box className='pedido-select-tab'>
                            <ColorButton onClick={() => setTab('pedido')} reverse={tab !== 'pedido'}>Pedido</ColorButton>
                            <ColorButton onClick={() => setTab('ficha')} reverse={tab !== 'ficha'}>Ficha Financeira</ColorButton>
                            <ColorButton onClick={() => setTab('historico')} reverse={tab !== 'historico'}>Histórico</ColorButton>
                        </Box>}
                    {tab === 'historico' && <Historic id={state.id} setData={setHistoric} data={historic} />}
                    {tab === 'ficha' && <FichaFinanceira valor={state.total_price} id={state.id} setData={setFicha} data={ficha} />}
                    <Box className='item-content-modal noborder' sx={tab !== 'pedido' ? { display: 'none' } : null}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Box className='item-profile-row'>
                                    <Grid container spacing={2}>
                                        <Grid item xs={3}>
                                            <FormControl fullWidth size="small" disabled={!validations.initialized || viewOnly}>
                                                <InputLabel id="tipo-pedido-label">Tipo de pedido</InputLabel>
                                                <Select
                                                    labelId="tipo-pedido-label"
                                                    id="tipo-pedido"
                                                    label="Tipo de pedido"
                                                    value={state.tipo_pedido}
                                                    onChange={({ target }) => setState({ tipo_pedido: target.value })}
                                                >
                                                    <MenuItem value={1}>Orçamento/Cotação (Não reserva pneus)</MenuItem>
                                                    <MenuItem value={2}>Pedido de Venda (Reserva pneus)</MenuItem>
                                                    {hasPermissions('administrador', 'bks') && <MenuItem value={3}>Carga de distribuição</MenuItem>}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <FormControl fullWidth size="small">
                                                <MegaAutoComplete
                                                    disabled={!(validations?.client_selected && hasPermissions('admfilial', 'administrador')) || viewOnly}
                                                    autoload
                                                    fullWidth={true}
                                                     internal={(representative_list, set_representative_list) => {
                                                         internal_representatives['data'] = representative_list
                                                         internal_representatives['set'] = set_representative_list
                                                     }}
                                                     initializeOptions={state.representative ? [state.representative] : null}
                                                    value={state.representative}
                                                    onChange={(data) => setState({ representative: data })}
                                                    noOptionsText={'Digite para procurar um Representante'}
                                                    timeoutUrl='/novopedido/representantes/'
                                                    timeoutParam='label'
                                                    test={true}
                                                    label='Representante'
                                                    sx={{ maxWidth: '8rem' }}
                                                />
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={3}>
                                            <FormControl fullWidth size="small">
                                                <MegaAutoComplete
                                                    disabled={!(state.branch && validations.client_selected) || state.products_rows?.length > 0}
                                                    fullWidth={true}
                                                    autoload
                                                    internal={(tabela_list) => {
                                                        tabelas_de_valores['data'] = tabela_list
                                                    }}
                                                    filterOptions={(options) =>
                                                        options.filter(tabela => tabela?.data?.filial.includes(state.origin_stock?.id))
                                                    }
                                                    value={state.values_table}
                                                    initializeOptions={state.values_table ? [state.values_table] : null}
                                                    onChange={(data) => setState({ values_table: data })}
                                                    noOptionsText={'Digite para procurar uma Tabela de preços'}
                                                    timeoutUrl='/tabelas/valores/'
                                                    timeoutParam='label'
                                                    label='Tabela de preços'
                                                    sx={{ maxWidth: '8rem' }}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <Divider sx={{ bgcolor: 'text.primary', marginTop: '16px' }} />
                            </Grid>
                            <Grid item xs={9}>

                                <Grid container spacing={2}>
                                    <Grid item xs={9}>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'flex-start',
                                                flexDirection: 'column',
                                                p: 1,
                                                border: '1px solid #bcbcbc',
                                                minHeight: '19.6rem',
                                            }}
                                        >
                                            <Grid container spacing={1}>
                                                <Grid item xs={12}>
                                                    <FormControl size="small" fullWidth={true}>
                                                        <MegaAutoComplete
                                                            disabled={!(validations?.product_selected) || state.id || (state.products_rows.length > 0)}
                                                            initializeOptions={state.costumer ? [state.costumer] : null}
                                                            value={state.costumer}
                                                            onChange={(data) => {
                                                                const hasrep = data?.data?.representante || null
                                                                let selected_rep = (internal_representatives.data?.data || []).find(rep => rep.id === hasrep?.id)
                                                                if (!selected_rep && hasrep) {
                                                                    internal_representatives.set({ data: [...internal_representatives.data.data, hasrep] })
                                                                    selected_rep = hasrep
                                                                }

                                                                setState({
                                                                    costumer: data,
                                                                    branch: data?.data?.filial,
                                                                    origin_stock: data?.data?.filial,
                                                                    city: data?.data?.cidade,
                                                                    representative: selected_rep ? selected_rep : state.representative,
                                                                })
                                                            }}
                                                            noOptionsText={'Clientes'}
                                                            timeoutUrl='/novopedido/clientes/'
                                                            timeoutParam='label'
                                                            label='Clientes'
                                                            replace={{
                                                                filterOptions: (options, state) => {
                                                                    const inputValue = normalize(state.inputValue); // Normalize user input
                                                                    return options.filter((option) =>
                                                                        normalize(option.label).includes(inputValue)
                                                                    ); // Filter options ignoring the mask
                                                                }
                                                            }}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                                <Grid className='margin_flex' item xs={8}>
                                                    <FormControl size="small" sx={{
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                    }}>
                                                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Cliente: </Typography>
                                                        <Typography variant="body1" sx={{ paddingLeft: '4px' }}> {state.costumer && state.costumer.data.nome}</Typography>
                                                    </FormControl>
                                                </Grid>
                                                <Grid className='margin_flex' item xs={4}>
                                                    <FormControl size="small" >
                                                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>CPF/CNPJ: </Typography>
                                                        <Typography variant="body1" sx={{ paddingLeft: '4px' }}>{state.costumer && (state.costumer.data.CPFCNPJ)}</Typography>
                                                    </FormControl>
                                                </Grid>

                                                <Grid className='margin_flex' item xs={8}>
                                                    <FormControl size="small" sx={{
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                    }}>
                                                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Endereço: </Typography>
                                                        <Typography variant="body1" sx={{ paddingLeft: '4px' }}> {state.costumer && state.costumer.data.Endereco}</Typography>
                                                    </FormControl>
                                                </Grid>
                                                <Grid className='margin_flex' item xs={4}>
                                                    <FormControl size="small" >
                                                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>CEP: </Typography>
                                                        <Typography variant="body1" sx={{ paddingLeft: '4px' }}>{state.costumer && state.costumer.data.CEP}</Typography>
                                                    </FormControl>
                                                </Grid>
                                                <Grid className='margin_flex' item xs={1}>
                                                    <FormControl size="small" >
                                                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>UF: </Typography>
                                                        <Typography variant="body1" sx={{ paddingLeft: '4px' }}>{state.city && state.city.UF}</Typography>
                                                    </FormControl>
                                                </Grid>
                                                <Grid className='margin_flex' item xs={3}>
                                                    <FormControl size="small" >
                                                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Cidade: </Typography>
                                                        <Typography variant="body1" sx={{ paddingLeft: '4px' }}>{state.city && state.city.label}</Typography>
                                                    </FormControl>
                                                </Grid>
                                                <Grid className='margin_flex' item xs={5}>
                                                    <FormControl size="small" >
                                                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>E-Mail: </Typography>
                                                        <Typography variant="body1" sx={{ paddingLeft: '4px' }}>{state.costumer && state.costumer.data.Email}</Typography>
                                                    </FormControl>
                                                </Grid>
                                                <Grid className='margin_flex' item xs={3}>
                                                    <FormControl size="small" >
                                                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Telefone: </Typography>
                                                        <Typography variant="body1" sx={{ paddingLeft: '4px' }}>{state.costumer && state.costumer.data.Telefone}</Typography>
                                                    </FormControl>
                                                </Grid>
                                                <Grid className='margin_flex' item xs={6}>
                                                    <FormControl size="small" >
                                                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Volume Comprado Mês:</Typography>
                                                        <Typography variant="body1" sx={{ paddingLeft: '4px' }}></Typography>
                                                    </FormControl>
                                                </Grid>
                                                <Grid className='margin_flex' item xs={6}>
                                                    <FormControl size="small" >
                                                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Saldo Garantia:</Typography>
                                                        <Typography variant="body1" sx={{ paddingLeft: '4px' }}></Typography>
                                                    </FormControl>
                                                </Grid>
                                                <Grid className='margin_flex' item xs={3}>
                                                    <FormControl size="small" >
                                                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Últ. Compra: </Typography>
                                                        <Typography variant="body1" sx={{ paddingLeft: '4px' }}>{state.costumer && dayjs(state.costumer.data.DataUltimaAlteracao).format('DD/MM/YYYY')}</Typography>
                                                    </FormControl>
                                                </Grid>
                                                <Grid className='margin_flex' item xs={2}>
                                                    <FormControl size="small" >
                                                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Dia(s):</Typography>
                                                        <Typography variant="body1" sx={{ paddingLeft: '4px' }}>{state.costumer && dayjs().diff(state.costumer.data.DataUltimaAlteracao, 'day')}</Typography>
                                                    </FormControl>
                                                </Grid>
                                                <Grid className='margin_flex' item xs={7}>
                                                    <FormControl size="small" >
                                                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Grupo Econômico:</Typography>
                                                        <Typography variant="body1" sx={{ paddingLeft: '4px' }}>{state.costumer && state.costumer.data.GrupoEconomico}</Typography>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'flex-start',
                                                flexDirection: 'column',
                                                p: 1,
                                                justifyContent: 'space-around',
                                                border: '1px solid #bcbcbc',
                                                minHeight: '19.6rem',
                                            }}
                                        >

                                            <FormControl size="small" fullWidth={true}>
                                                <MegaAutoComplete
                                                    disabled={!validations?.client_selected || state.products_rows?.length > 0 || state.values_table}
                                                    fullWidth={true}
                                                    value={state.branch}
                                                    initializeOptions={state.branch ? [state.branch] : null}
                                                    onChange={(data) => {
                                                        const setoriginstock = internal_origin_stock?.data?.data.find(stock => stock?.id === data?.id) ||
                                                            null
                                                        setState({ branch: data, origin_stock: setoriginstock })
                                                    }
                                                    }
                                                    noOptionsText={'Digite para procurar uma Filial'}
                                                    timeoutUrl='/frete/filiais/pedido'
                                                    timeoutParam='label'
                                                    label='Filial'
                                                    sx={{ maxWidth: '8rem' }}
                                                />
                                            </FormControl>

                                            <FormControl size="small" fullWidth={true}>
                                                <MegaAutoComplete
                                                    disabled={!validations?.client_selected || state.products_rows?.length > 0 || state.values_table}
                                                    fullWidth={true}
                                                    value={state.origin_stock}
                                                    internal={(origin_stock_list, set_origin_stock_list) => {
                                                        internal_origin_stock['data'] = origin_stock_list
                                                        internal_origin_stock['set'] = set_origin_stock_list
                                                    }}
                                                    filterOptions={(options) => {
                                                        const label = state.branch?.label
                                                        if (label && (label.includes('CD') || label.includes('SO'))) {
                                                            return options.filter(e => e.label.includes('BKS') || state.branch?.id === e.id)
                                                        } else if (label && label.includes('VT')) {
                                                            return options.filter(e => e.label.includes('BKS'))
                                                        } else {
                                                            return options
                                                        }
                                                    }}
                                                    initializeOptions={state.origin_stock ? [state.origin_stock] : null}
                                                    onChange={(data) => setState({ origin_stock: data })}
                                                    noOptionsText={'Digite para procurar um Estoque de Origem'}
                                                    timeoutUrl='/tabela/estoque/'
                                                    timeoutParam='label'
                                                    label='Estoque de Origem'
                                                    sx={{ maxWidth: '8rem' }}
                                                />
                                            </FormControl>
                                            <FormControl size="small" fullWidth={true} disabled={!validations?.table_selected || viewOnly}>
                                                {state.card ?
                                                    <>
                                                        <InputLabel focused={false} id='select-cond-pag'>Tipo Documento</InputLabel>
                                                        <Select
                                                            focused={false}
                                                            value={state.document_type}
                                                            className='cond-pag-select-field'
                                                            labelId='select-cond-pag'
                                                            label='Tipo Documento'
                                                            onChange={({ target }) => {
                                                                if (target.value === -1)
                                                                    setState({  document_type: '',
                                                                                card: null, 
                                                                                payment_condition: state.payment_condition?.fromCard? null: state.payment_condition  }
                                                                )
                                                                else
                                                                    setState({ card: { ...state.card, open: true } })
                                                            }}
                                                        >
                                                            <MenuItem value={state.document_type}>{state.card?.flag?.label} {state.card?.debito ? 'Débito': 'Crédito'}</MenuItem>
                                                            <MenuItem value={null}>{'Alterar'}</MenuItem>
                                                            <MenuItem value={-1}>{'Remover'}</MenuItem>
                                                        </Select>
                                                    </>
                                                    :
                                                    state.bank ?
                                                        <>
                                                            <InputLabel focused={false} id='select-cond-pag'>Tipo Documento</InputLabel>
                                                            <Select
                                                                focused={false}
                                                                value={state.document_type}
                                                                className='cond-pag-select-field'
                                                                labelId='select-cond-pag'
                                                                label='Tipo Documento'
                                                                onChange={({ target }) => {
                                                                    if (target.value === -1)
                                                                        setState({ document_type: '', bank: null })
                                                                    else
                                                                        setState({ bank: { ...state.bank, open: true } })
                                                                }}
                                                            >
                                                                <MenuItem value={state.document_type}>{state.document_type?.label}</MenuItem>
                                                                <MenuItem value={null}>{'Alterar'}</MenuItem>
                                                                <MenuItem value={-1}>{'Remover'}</MenuItem>
                                                            </Select>
                                                        </>
                                                        :
                                                        <MegaAutoComplete
                                                            disabled={!validations?.table_selected || viewOnly}
                                                            value={state.document_type}
                                                            initializeOptions={state.document_type ? [state.document_type] : null}
                                                            onChange={(data) => {
                                                                let payment_condition = state.payment_condition
                                                                if (!data?.data?.tipo) {
                                                                    if (state?.payment_condition?.avista)
                                                                        payment_condition = null
                                                                    else
                                                                        payment_condition = state.payment_condition
                                                                } else if (data?.data?.tipo)
                                                                    payment_condition = { ...data?.data?.tipo, avista: true }
                                                                setState({ document_type: data, payment_condition: payment_condition })
                                                            }}
                                                            noOptionsText={'Digite para procurar um tipo de documento'}
                                                            timeoutUrl='/novopedido/tipo_documento/'
                                                            timeoutParam='label'
                                                            label='Tipo Documento'
                                                            sx={{ maxWidth: '9rem' }}
                                                        />
                                                }
                                            </FormControl>
                                            <FormControl size="small" fullWidth={true} disabled={!validations?.table_selected || viewOnly}>
                                                {state.payment_condition?.avista ?
                                                    <>
                                                        <InputLabel focused={false} id='select-cond-pag'>Condição de Pagamento</InputLabel>
                                                        <Select
                                                            focused={false}
                                                            value={state.payment_condition?.id || ''}
                                                            disabled
                                                            className='cond-pag-select-field'
                                                            labelId='select-cond-pag'
                                                            label='Condição de Pagamento'
                                                        >
                                                            <MenuItem value={state.payment_condition?.id}>{state.payment_condition?.label}</MenuItem>
                                                        </Select>
                                                    </>
                                                    :
                                                    <>
                                                        {
                                                            state.payment_condition?.id === -1 ?
                                                                <>
                                                                    <InputLabel focused={false} id='select-cond-pag'>Condição de Pagamento</InputLabel>
                                                                    <Select
                                                                        focused={false}
                                                                        value={state.payment_condition}
                                                                        className='cond-pag-select-field'
                                                                        labelId='select-cond-pag'
                                                                        label='Condição de Pagamento'
                                                                        onChange={({ target }) => setState({ payment_condition: target.value })}
                                                                    >
                                                                        <MenuItem value={state.payment_condition}>{state.payment_condition?.label}</MenuItem>
                                                                        <MenuItem value={{ id: -1 }}>{'Alterar'}</MenuItem>
                                                                        <MenuItem value={null}>{'Remover'}</MenuItem>
                                                                    </Select>
                                                                </> :
                                                                <MegaAutoComplete
                                                                    disabled={!validations?.table_selected || viewOnly || state.payment_condition?.fromCard}
                                                                    value={state.payment_condition}
                                                                    initializeOptions={state.payment_condition ? [state.payment_condition] : null}
                                                                    onChange={(data) => setState({ payment_condition: data })}
                                                                    noOptionsText={'Digite para procurar uma condição de pagamento'}
                                                                    timeoutUrl='/novopedido/condicao_pagamento/'
                                                                    timeoutParam='label'
                                                                    label='Condição de Pagamento'
                                                                />
                                                        }
                                                    </>
                                                }
                                            </FormControl>

                                            <FormControl size="small" fullWidth={true} disabled={!validations?.table_selected || viewOnly}>
                                                <InputLabel id="frete-label">Frete</InputLabel>
                                                <Select
                                                    labelId="frete-label"
                                                    id="frete"
                                                    label="Frete"
                                                    value={state.shipping}
                                                    onChange={(e) => 
                                                        setState({ shipping: e.target.value,
                                                             shipping_flag: (e.target.value === 2) ? true : false, 
                                                             carrier: (e.target.value === 2) ? {id:0, label:''} : state.carrier })
                                                    }
                                                >
                                                    <MenuItem value={1}>CIF</MenuItem>
                                                    <MenuItem value={2}>FOB</MenuItem>
                                                </Select>
                                            </FormControl>

                                            <FormControl size="small" fullWidth={true}>
                                                <MegaAutoComplete
                                                    disabled={!validations?.table_selected || viewOnly || state.shipping === 2}
                                                    fullWidth={true}
                                                    value={state.carrier}
                                                    initializeOptions={state.carrier ? [state.carrier] : null}
                                                    onChange={(data) => setState({ carrier: data })}
                                                    noOptionsText={'Digite para procurar uma Transportadora'}
                                                    timeoutUrl='/novopedido/transportadoras/'
                                                    timeoutParam='label'
                                                    label='Transportadora'
                                                    sx={{ maxWidth: '8rem' }}
                                                />
                                            </FormControl>

                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={3} className="desc-saldos">
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        flexDirection: 'row',
                                        gap: '8px',
                                        width: '100%'
                                    }}
                                >
                                    <Box
                                        sx={{
                                            position: 'relative',
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            flexDirection: 'column',
                                            p: 1,
                                            justifyContent: 'space-around',
                                            border: '1px solid #bcbcbc',
                                            maxHeight: '8rem',
                                            width: '100%'
                                        }}
                                    >
                                        <FormLabel className="grid-label" >Descontos</FormLabel>
                                        <FormGroup sx={{ width: '100%' }}>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    width: '100%',
                                                }}
                                            >
                                                <FormControlLabel checked={calc_payment_condition} readonly control={<Checkbox />} label="Cond. Pag." sx={{ maxHeight: '1.5rem' }} />
                                                {calc_payment_condition !== 0 &&
                                                    <Typography variant="body1" sx={{ fontWeight: 'bold', color: calc_payment_condition * -1 < 0 ? '#c60000' : 'blue' }}>
                                                        {formatPercentage(calc_payment_condition * -1)}
                                                    </Typography>
                                                }
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    width: '100%',
                                                }}
                                            >
                                                <FormControlLabel checked={state.shipping_flag} readonly control={<Checkbox />} label="Frete" sx={{ maxHeight: '1.5rem' }} />
                                                {state.shipping_flag &&
                                                    <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#c60000' }}>
                                                        -{formatPercentage(configs?.preco_frete?.value_perc)}
                                                    </Typography>
                                                }
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    width: '100%',
                                                }}
                                            >
                                                <FormControlLabel readonly checked={Boolean(state.commission_percent) && (state.commission_percent !== last_comission)} control={<Checkbox />} label="Comissão" sx={{ maxHeight: '1.5rem' }} />
                                                {Boolean(state.commission_percent) && (state.commission_percent !== last_comission) &&
                                                    <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#c60000' }}>
                                                        {formatPercentage((last_comission - state.commission_percent) * -10000)}
                                                    </Typography>
                                                }
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    width: '100%',
                                                }}
                                            >
                                                <FormControlLabel readonly checked={Boolean(state.costumer?.data?.volume_discount)} control={<Checkbox />} label="Volume" sx={{ maxHeight: '1.5rem' }} />
                                                {Boolean(state.costumer?.data?.volume_discount)  &&
                                                    <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#c60000' }}>
                                                        {formatPercentage(-1*(state.costumer?.data?.volume_discount || 0))}
                                                    </Typography>
                                                }
                                            </Box>
                                        </FormGroup>
                                    </Box>

                                    <Box
                                        sx={{
                                            position: 'relative',
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            flexDirection: 'column',
                                            p: 1,
                                            justifyContent: 'space-around',
                                            border: '1px solid #bcbcbc',
                                            minHeight: '7rem',
                                            width: '100%'
                                        }}
                                    >
                                        <FormLabel className="grid-label" >Saldos</FormLabel>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                width: '100%',
                                            }}
                                        >
                                            <Typography variant="body1">Saldo do Pedido:</Typography>
                                            <Typography variant="body1">
                                                {formatCurrency(state.saldo_ped / 100)}
                                            </Typography>
                                        </Box>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                width: '100%',
                                            }}
                                        >
                                            <Typography variant="body1">Saldo do Mês:</Typography>
                                            <SaldoBox representative={state.representative} saldoRep={saldoRep} setSaldoRep={(data) => setSaldoRep(data)} />
                                        </Box>
                                        <Divider sx={{ bgcolor: 'text.primary', width: '100%', opacity: 1 }} />
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                width: '100%',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Saldo Final:</Typography>
                                            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                                {formatCurrency(((saldoRep?.saldo || 0) + (state.saldo_ped || 0)) / 100)}
                                            </Typography>
                                        </Box>
                                        <FormControlLabel control={<Checkbox />} label="Utiliza Saldo do Mês" sx={{ maxHeight: '1.5rem' }} />
                                    </Box>
                                </Box>
                                <Grid item xs={12}>
                                    <PoolTextField
                                        disabled={!validations.product_selected || viewOnly}
                                        label="Observação"
                                        multiline
                                        rows={4}
                                        fullWidth={true}
                                        value={state.observation}
                                        onChange={(e) => {
                                            setState({ observation: e.target.value })
                                        }}
                                        sx={{ marginTop: '1rem' }}
                                        size="small"
                                    />
                                </Grid>
                                <Grid container spacing={2} sx={{ marginTop: '0.5rem' }}>
                                    <Grid item xs={8}>
                                        <FormControl size="small" fullWidth={true} disabled={!validations.product_selected}>
                                            <InputLabel id="orcamento-mae-label">Orc. Mãe</InputLabel>
                                            <Select
                                                labelId="orcamento-mae-label"
                                                id="orcamento-mae"
                                                label="Orc. Mãe"
                                                value=''
                                                onChange={() => { }}
                                            >
                                                <MenuItem value={1}>Teste</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <ColorButton>Pedidos Filhos</ColorButton>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} sx={{ minHeight: '20rem' }}>
                            <Grid item xs={10} sx={{ maxHeight: '20rem' }}>

                                <Table
                                    disableRowSelectionOnClick
                                    rows={state.products_rows}
                                    columns={memo_columns}
                                    className='red-button'
                                    density='compact'
                                    getRowClassName={({ id }) => Boolean(state.pendencias?.[id] || null) ? 'is-refused' : ''}
                                    toolbar={Boolean(state.values_table?.id && validations.table_selected && !viewOnly)}
                                    slots={{
                                        addComponent: () => { state.values_table?.id ? setModal({ product_modal: {} }) : toast.error('Selecione uma tabela de preço') }
                                    }}
                                    getURL={''}
                                />
                            </Grid>
                            <Grid item xs={2} sx={{
                                minHeight: '20rem',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                            }}>
                                <Box>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            width: '100%',
                                        }}
                                    >
                                        <Typography variant="body1">Peso Total(Kg):</Typography>
                                        <Typography variant="body1">
                                            {state.weight.toFixed(2)}
                                        </Typography>
                                    </Box>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            width: '100%',
                                        }}
                                    >
                                        <Typography variant="body1">M³ Total:</Typography>
                                        <Typography variant="body1">
                                            {state.cube_size.toFixed(5)}
                                        </Typography>
                                    </Box>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            width: '100%',
                                        }}
                                    >
                                        <Typography variant="body1">Quant Total:</Typography>
                                        <Typography variant="body1">
                                            {state.quantity}
                                        </Typography>
                                    </Box>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            width: '100%',
                                        }}
                                    >
                                        <Typography variant="body1">Subtotal:</Typography>
                                        <Typography variant="body1">
                                            0,00
                                        </Typography>
                                    </Box>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            width: '100%',
                                        }}
                                    >
                                        <Typography variant="body1">Desconto:</Typography>
                                        <Typography variant="body1">
                                            R$0,00
                                        </Typography>
                                    </Box>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            width: '100%',
                                        }}
                                    >
                                        <Typography variant="body1">Desc. Gar.:</Typography>
                                        <Typography variant="body1">
                                            R$0,00
                                        </Typography>
                                    </Box>
                                    <Divider sx={{ bgcolor: 'text.primary', width: '100%', opacity: 1 }} />
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            width: '100%',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Comissão %:</Typography>
                                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                            {formatPercentage(state.commission_percent * 10000)}
                                        </Typography>
                                    </Box>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            width: '100%',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Comissão Total:</Typography>
                                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                            {formatCurrency(state.commission_amount / 100)}
                                        </Typography>
                                    </Box>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            width: '100%',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Valor Total:</Typography>
                                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                            {formatCurrency(state.total_price / 100)}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>

                        {viewOnly && state.pendencias &&
                            <Box className='pedido-always-show'>
                                <Box className='pedido-hide-background'></Box>
                                <Box className='pedido-pendencias-show'>
                                    Pendências: {[...Array.from(new Set(Object.values(state.pendencias || {}).flatMap(pendencia => pendencia)))
                                    ].join(', ')}
                                </Box>
                                {hasPermissions('administrador', 'grupo_administradores') && state.liberacao === 'aguardando' &&
                                    <Box className='inverted-edit-actions'>
                                        {Boolean(state.id) && <ColorButton onClick={() => refuseModal(state.id, state.hash)} >Recusar</ColorButton>}
                                        {Boolean(state.id) && <ColorButton onClick={() => setModal({ libera_pedido: state })} >Liberar</ColorButton>}
                                    </Box>}
                            </Box>
                        }

                    </Box>
                </>
            }
            action={
                (tab === 'pedido') ? <>
                    {state.pendencias &&
                        <Box className='pendencias-edit-actions'>
                            Pendências: {[...Array.from(new Set(Object.values(state.pendencias || {}).flatMap(pendencia => pendencia)))
                            ].join(', ')}
                        </Box>}
                    <Box className='inverted-edit-actions'>
                        {['', 'aguardando_liberacao', 'aguardando_envio'].includes(state.status) &&
                            <>
                                {(Boolean(state.id) && !state.clean) ? <Tooltip placement='top' title='Pedido alterado'><WarningIcon color='warning' /></Tooltip> : ''}
                                {Boolean(state.id) && hasPermissions('administrador') && 
                                    <ColorButton
                                        onClick={() => setModal({ inibe_cancelamento: state })} >
                                            {state.ignore_cancel ? "Liberar":"Inibir"} Cancelamento
                                    </ColorButton>
                                }
                                {Boolean(state.id) && <ColorButton onClick={() => setModal({ cancel: state })} >Inutilizar</ColorButton>}
                                {(Boolean(state.id)) && state.liberacao === '' &&
                                    <ColorButton
                                        disabled={!state.clean}
                                        onClick={() => setModal({
                                            liberation: (state.status === 'aguardando_envio' ?
                                                'Faturamento' : 'Liberação')
                                        })}
                                    >Solicitar {state.status === 'aguardando_envio' ? 'Faturamento' : 'Liberação'}
                                    </ColorButton>
                                }
                                {(Boolean(state.id) && Boolean(state.status === 'aguardando_envio')) &&
                                    <ColorButton
                                        onClick={() => setModal({ send: () => submit_elevor({ ...state, discount: discount }, reloadData, setLoader, () => loadRetrieve(state.id, setState, setLoader)) })}
                                        disabled={!(validations?.valid) || !state.clean}
                                    >Enviar Elevor
                                    </ColorButton>
                                }
                                <Tooltip placement="left">
                                    <Box>
                                        <ColorButton
                                            disabled={!(validations?.valid)}
                                            onClick={() => setModal({ save: () => submit({ ...state, discount: discount }, reloadData, setLoader, (newid) => loadRetrieve(newid || state.id, setState, setLoader)) })}
                                        >{getTitle(state)}
                                        </ColorButton>
                                    </Box>
                                </Tooltip>
                            </>
                        }
                    </Box>
                </>
                    : null
            }
        />
    </>
    )
}

export default EditPedido;